import { useTranslation } from 'react-i18next';

import { PrismaLogo } from '@global-components/PrismaLogo';

/* eslint-disable @next/next/no-img-element */
export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="copyright">
        <p>© 2023 Prisma. {t(`footer.allRightsReserved`)}.</p>
      </div>
      <div className="powered-by">
        <p>Powered by</p>
        <PrismaLogo />
      </div>
    </footer>
  );
};
